// extracted by mini-css-extract-plugin
export var option = "_65-0";
export var optionCard = "_65-f";
export var optionContent = "_65-g";
export var optionIcon = "_65-i";
export var optionIconBox = "_65-h";
export var optionLabel = "_65-j";
export var optionPill = "_65-m";
export var optionPillBadge = "_65-p";
export var optionPillIcon = "_65-n";
export var optionPillLabel = "_65-o";
export var optionRadio = "_65-k";
export var optionRadioInner = "_65-l";
export var optionReveal = "_65-2";
export var optionRevealDelay0 = "_65-3";
export var optionRevealDelay1 = "_65-4";
export var optionRevealDelay10 = "_65-d";
export var optionRevealDelay11 = "_65-e";
export var optionRevealDelay2 = "_65-5";
export var optionRevealDelay3 = "_65-6";
export var optionRevealDelay4 = "_65-7";
export var optionRevealDelay5 = "_65-8";
export var optionRevealDelay6 = "_65-9";
export var optionRevealDelay7 = "_65-a";
export var optionRevealDelay8 = "_65-b";
export var optionRevealDelay9 = "_65-c";
export var optionSelected = "_65-1";